<template>
  <Popover ref="popover" :showHeader="true" :headerTitle="title" sizeClass="popover-medium">
    <div class="p-2">
      <div v-if="task.deliveryStartedDate">
        <div class="font-weight-bold">Delivery Start Time</div>
        <div>{{formatDateTime(task.deliveryStartedDate)}}</div>
      </div>
      <div v-if="task.routeStartLocationDeparted">
        <div class="font-weight-bold">Start Location - Departure Time</div>
        <div>{{formatDateTime(task.routeStartLocationDepartedDate)}}</div>
      </div>
      <div v-if="task.routeEndLocationArrived">
        <div class="font-weight-bold">End Location - Arrival Time</div>
        <div>{{formatDateTime(task.routeEndLocationArrivedDate)}}</div>
      </div>
      
    </div>
  </Popover>
</template>

<script>
import Popover from '@/components/popover'

export default {
  name: 'MapTaskEndpointPopover',
  components: {
    Popover
  },
  data() {
    return {
      task: {}
    }
  },
  computed: {
    title() {
      return 'Task Route'
    },
  },
  methods: {
    displayFromElement(element, task) {
      this.$refs.popover.displayFromElement(element)

      // Reset
      this.task = task
    }
  }
}
</script>